export const PRIVACY_URL = "https://leggeraflow.it/privacy";
export const SHOP_URL = "https://shop.mattiamilanipersonaltrainer.it";
export const PRODUCT_URL =
  "https://shop.mattiamilanipersonaltrainer.it/prodotto/leggera-flow-sgonfia-in-20-giorni/";
